import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { login } from '../../../services/auth';
import { Toast } from '../Alert/Toast';
import { IS_NEW, IS_REGISTERED } from '../../../constants/form';
import { restartForm } from '../../../utils/forms.util';

const AuthenticationModal = ({ show, handleClose, setCustomerType }) => {
  const [email, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);

  const handleLogin = async () => {
    try {
      const { token, message } = await login({ email, password });
      Toast.fire({
        icon: "success",
        title: message,
      });
      sessionStorage.setItem("token", token);
      setCustomerType(IS_NEW)
      handleClose();
      restartForm()
    } catch (error) {
      setCustomerType(IS_REGISTERED)
      console.log("Error", error);
      setError("Email o contraseña incorrectos");
    }
  };

  const handleModalHide = () => {
    setCustomerType(IS_REGISTERED)
    handleClose();
  };

  return (
    <Modal show={show} onHide={handleModalHide}>
      <Modal.Header closeButton>
        <Modal.Title>Autenticación Requerida</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group controlId="formEmail">
            <Form.Label>Email</Form.Label>
            <Form.Control
              type="email"
              placeholder="Ingrese su email"
              value={email}
              onChange={(e) => setUsername(e.target.value)}
            />
          </Form.Group>
          <Form.Group controlId="formPassword">
            <Form.Label>Contraseña</Form.Label>
            <Form.Control
              type="password"
              placeholder="Ingrese su contraseña"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </Form.Group>
          {error && <p style={{ color: 'red' }}>{error}</p>}
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleModalHide}>
          Cerrar
        </Button>
        <Button variant="primary" onClick={handleLogin}>
          Ingresar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AuthenticationModal;
